/* eslint-disable*/
import React, { useEffect, useState } from "react";
import { InputBox, SubmitButton, TextAreaBox } from "../../components/Input";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../config";
import { showToast } from "../../components/toast.jsx";
import LoadingSpinner from "../../components/LoadingSpinner";

const EditPageSeo = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [seoTitle, setSeoTitle] = useState("");
  const [seoDesc, setSeoDesc] = useState("");
  const [metaTags, setMetaTags] = useState("");
  const [schemaScriptAddition, setSchemaScriptAddition] = useState("");
  const [faqList, setFaqList] = useState([]);
  const [pageName, setPageName] = useState("");
  const [loading, setLoading] = useState(false);

  // Fetch data on mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${API_URL}pages/edit/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (res.data) {
          const data = res.data.page;
          setPageName(data.page_name || "");
          setSeoTitle(data.seo_title || "");
          setSeoDesc(data.seo_desc || "");
          setMetaTags(data.meta_tags || "");
          setSchemaScriptAddition(data.schema_script_addition || "");

          // ✅ map title → question, description → answer
          const mappedFaqs = (res.data.faqs || []).map((faq) => ({
            id: faq.id,
            question: faq.title,
            answer: faq.description,
          }));
          setFaqList(mappedFaqs);
        }
      } catch (err) {
        console.error("Error fetching page data", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const addFaq = () => {
    setFaqList([...faqList, { id: null, question: "", answer: "" }]);
  };

  const deleteFaq = (faqId) => {
    setFaqList(faqList.filter((faq) => faq.id !== faqId));
  };

  const handleFaqChange = (index, field, value) => {
    const updatedFaqs = [...faqList];
    updatedFaqs[index][field] = value;
    setFaqList(updatedFaqs);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const faqids = faqList.map((faq) => faq.id).filter((id) => id !== null);
    const question = faqList.map((faq) => faq.question);
    const answer = faqList.map((faq) => faq.answer);

    const payload = {
      seo_title: seoTitle,
      seo_desc: seoDesc,
      meta_tags: metaTags,
      schema_script_addition: schemaScriptAddition,
      faqids,
      question,
      answer,
    };

    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");

      // ✅ Backend expects ?id= query param
      const res = await axios.post(`${API_URL}pages/save?id=${id}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (res.status === 201) {
        showToast.success("SEO Page Updated Successfully", "success");
        navigate("/Seo/Pages");
      } else {
        showToast.error("Failed to update", "error");
      }
    } catch (error) {
      console.error("Error updating page", error);
      showToast.error("Something went wrong!", "error");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="page-container page-header-fixed page-sidebar-fixed fade in mt-5">
      <div className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <form onSubmit={handleSubmit} className="stdform">
            <input type="hidden" name="id" value={id} />
            <div className="panel-heading border-0">
              <span className="panel-title">Edit SEO - {pageName}</span>
            </div>

            <div className="panel-body">
              <div className="row">
                <div className="col-md-4 mb-2">
                  <InputBox
                    label="SEO Title"
                    fieldname="seo_title"
                    placeholder="Enter Seo Title"
                    value={seoTitle}
                    onChange={(e) => setSeoTitle(e.target.value)}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <TextAreaBox
                    label="SEO Description"
                    fieldname="seo_desc"
                    placeholder="Enter Seo Description"
                    value={seoDesc}
                    onChange={(e) => setSeoDesc(e.target.value)}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <TextAreaBox
                    label="Meta Tags"
                    fieldname="meta_tags"
                    placeholder="Enter Meta Tags"
                    value={metaTags}
                    onChange={(e) => setMetaTags(e.target.value)}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <TextAreaBox
                    label="Schema Script Addition"
                    fieldname="schema_script_addition"
                    placeholder="Enter Schema Script Addition"
                    value={schemaScriptAddition}
                    onChange={(e) => setSchemaScriptAddition(e.target.value)}
                  />
                </div>
              </div>

              {/* FAQ Section */}
              <div className="faq_div mt-5">
                <div className="panel-heading p-0">
                  <span className="panel-title">
                    Frequently Asked Questions
                  </span>
                </div>

                <table className="table m-b-0 col-12">
                  <thead>
                    <tr>
                      <th style={{ textAlign: "center", width: "30%" }}>
                        Title
                      </th>
                      <th style={{ textAlign: "center", width: "30%" }}>
                        Description
                      </th>
                      <th style={{ textAlign: "center", width: "10%" }}>
                        Delete
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {faqList.map((faq, index) => (
                      <tr key={faq.id || index}>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={faq.question}
                            onChange={(e) =>
                              handleFaqChange(index, "question", e.target.value)
                            }
                            placeholder="FAQ Question"
                          />
                        </td>
                        <td>
                          <textarea
                            className="form-control"
                            value={faq.answer}
                            onChange={(e) =>
                              handleFaqChange(index, "answer", e.target.value)
                            }
                            placeholder="FAQ Answer"
                          />
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => deleteFaq(faq.id)}
                          >
                            X Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan="3">
                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={addFaq}
                        >
                          Add Data
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="form-group">
                <SubmitButton
                  pageBack="/Seo/Pages"
                  handleSubmit={handleSubmit}
                  disabled={loading}
                />
                {loading && <div className="mt-2">Saving changes...</div>}
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* Scroll top button */}
      <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
        <i className="ti-arrow-up"></i>
      </a>
    </div>
  );
};

export default EditPageSeo;
